import React from "react";
import { Route, Routes } from "react-router-dom";
import Dashbord from "@modules/dashbord/dashbord.tsx";
import Setting from "@modules/setting/setting.tsx";
import MainLayout from "@components/MainLayout.tsx";
import AuthGuard from "@core/guards/AuthGuard.tsx";
import ListingUser from "@modules/setting/userManagement/listingUser/listingUser.tsx";
import AddingUser from "@modules/setting/userManagement/addingUser/addingUser.tsx";
import ListComplaint from "@modules/plaintes/complaintManaging/listingComplaint/listComplaint.tsx";
import AddComplaint from "@modules/plaintes/complaintManaging/addingComplaint/addComplaint.tsx";
import DetailUser from "@modules/setting/userManagement/detailUser/detailUser.tsx";
import DetailComplaint from "@modules/plaintes/complaintManaging/detailComplaint/detailComplaint.tsx";
import Profile from "@modules/setting/userManagement/profile/profile.tsx";
import AddingProfile from "@modules/setting/userManagement/profile/addProfile.tsx";
import DetailProfile from "@modules/setting/userManagement/profile/detailProfile.tsx";
import AuditLogPage from "@modules/setting/auditLog/AuditLogPage.tsx";
import { userConnected } from "@core/slice/UsersSlice.ts";
import { useAppSelector } from "@core/store/hook.ts";
import { TypeProfil } from "@modules/plaintes/plaintes.model.ts";
import AccessGuard from "@core/guards/AccessGuard.tsx";
import InterimAgentPage from "@modules/setting/userManagement/interimAgent/interimAgent.tsx";

const AppRoutes: React.FC = () => {
  const detailsUserConnected = useAppSelector(userConnected);
  const isCompetentEntity =
    detailsUserConnected?.profil.type === TypeProfil.COMPETENT_ENTITY;
  const isExternalOrAdmin =
    detailsUserConnected &&
    (detailsUserConnected.profil.type === TypeProfil.EXTERNAL ||
      detailsUserConnected.profil.type === TypeProfil.ADMIN ||
      detailsUserConnected.profil.type === TypeProfil.RGS ||
      detailsUserConnected.profil.type === TypeProfil.ADMIN_DRPS ||
      detailsUserConnected.profil.type === TypeProfil.PFM ||
      detailsUserConnected.profil.type === TypeProfil.CGP);
  const isAdmin =
    detailsUserConnected &&
    (detailsUserConnected.profil.type === TypeProfil.ADMIN ||
      detailsUserConnected.profil.type === TypeProfil.ADMIN_DRPS);
  return (
    <Routes>
      {
        <Route
          path="/"
          element={
            <AuthGuard>
              <MainLayout />
            </AuthGuard>
          }
        >
          <Route path="/" element={<Dashbord />} />
          <Route path="/setting/data" element={<Setting />} />
          <Route path="/setting/list-user" element={<ListingUser />} />
          <Route path="/complaint/list-complaint" element={<ListComplaint />} />
          <Route
            path="/complaint/add-complaint"
            element={
              <AccessGuard canAccess={!isExternalOrAdmin}>
                <AddComplaint />
              </AccessGuard>
            }
          />
          <Route
            path="/complaint/detail-complaint/:id"
            element={<DetailComplaint />}
          />
          <Route path="/setting/group" element={<Profile />} />
          <Route
            path="/setting/group/add-group"
            element={
              <AccessGuard canAccess={!isCompetentEntity}>
                <AddingProfile />
              </AccessGuard>
            }
          />
          <Route
            path="/setting/group/add-group/:id"
            element={
              <AccessGuard canAccess={!isCompetentEntity}>
                <AddingProfile />
              </AccessGuard>
            }
          />
          <Route
            path="/setting/group-detail/:id"
            element={<DetailProfile />}
          />
          <Route
            path="/setting/add-user/:id"
            element={
              <AccessGuard canAccess={!isCompetentEntity}>
                <AddingUser />
              </AccessGuard>
            }
          />
          <Route
            path="/setting/add-user"
            element={
              <AccessGuard canAccess={!isCompetentEntity}>
                <AddingUser />
              </AccessGuard>
            }
          />
          <Route path="/setting/view-detail/:id" element={<DetailUser />} />
          <Route
            path="/setting/audit-log"
            element={
              <AccessGuard canAccess={detailsUserConnected?.profil?.type === TypeProfil.ADMIN}>
                <AuditLogPage />
              </AccessGuard>
            }
          />
          <Route
            path="/setting/interim-agent"
            element={
              <AccessGuard canAccess={!!isAdmin}>
                <InterimAgentPage />
              </AccessGuard>
            }
          />
          {/* <Route path="/notification/view-detail-notification-dernieres/:id" element={<Notification_sociaux_pea_notification_details_yeux />} /> */}
        </Route>
      }
    </Routes>
  );
};

export default AppRoutes;
